<template>
  <div>
    <el-table :data="auditList">
      <el-table-column min-width="60" label="时间">
        <template slot-scope="scope">{{scope.row.createdTime | moment}}</template>
      </el-table-column>
      <el-table-column label="账号">
        <template slot-scope="scope">
          <div class="copystyle">
            <a class="account-link" @click="getUserDetail(scope.row.userId)">{{scope.row.userId}}</a>
            <img width="18px" @click="getcopy(scope.row.userId)" src="../../../../../assets/images/copy.png"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="txCoin" label="币种"></el-table-column>
      <el-table-column prop="txAmount" label="充值数量"></el-table-column>
      <el-table-column label="充值地址" min-width="150">
        <template slot-scope="scope">
          <a
            :href="scope.row.txNetworkLink"
            target="_blank"
            class="network-link"
          >{{scope.row.txToAddress}}</a>
        </template>
      </el-table-column>
            <el-table-column label="充值地址memo">
              <template slot-scope="scope">
                <a
                  :href="scope.row.txNetworkLink"
                  target="_blank"
                  class="network-link"
                >{{scope.row.txToMemo}}</a>
              </template>
            </el-table-column>
      <el-table-column label="hash">
        <template slot-scope="scope">
          <a :href="scope.row.txHash" target="_blank" class="network-link">{{scope.row.txHash}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="充值状态">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.__status.color"
            v-if="scope.row.txStatus == 8"
          >{{scope.row.__status.text}}</el-tag>
          <span v-if="scope.row.txStatus != 8" class="text-disabled">{{scope.row.__status.text}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="人工确认">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__depositStatus.color">{{scope.row.txDepositDesc}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" show-overflow-tooltip label="备注"></el-table-column>
      <el-table-column prop="extraInfo" show-overflow-tooltip label="其他信息"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-tooltip content="确认">
            <el-button
              type="success"
              size="small"
              circle
              icon="el-icon-success"
              @click="markAuditSuccess(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="异常">
            <el-button
              type="danger"
              @click="markAuditFailure(scope.row)"
              icon="el-icon-warning"
              size="small"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap" style="text-align:right;margin:10px 0px;">
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="audistCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </div>
<!--    <div class="user-withdrawal-records-wrap">-->
<!--      <el-dialog :visible.sync="showUserDialog" title="账户余额信息" width="1200px">-->
<!--        <withdraw-records v-if="showUserDialog" :uid="nowUserId"></withdraw-records>-->
<!--      </el-dialog>-->
<!--    </div>-->
    <div class="send-trans-dialog">
      <el-dialog :visible.sync="ifShowSendDialog" @close="closeSendDialog" width="800px">
        <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
          <el-form-item
            prop="transId"
            label="网络ID"
            :rules="[
            {required: true, message: '请输入网路ID'}
          ]"
          >
            <el-input v-model="sendTransForm.transId"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="sendTransNow()">确定提交</el-button>
            <el-button @click="closeSendDialog()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <balance :show="showUserDialog" @close="showUserDialog = false"></balance>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import WithdrawRecords from "../records";
import balance from '../../../balance'
import Pagination from "components/pagination";

export default {
  name: "AuditList",
  data() {
    return {
      showUserDialog: false,
      ifShowSendDialog: false,
      nowUserId: "",
      sendOrderId: "",
      sendTransForm: {
        id: ""
      },
      retryableStatus: [
        "FAIL_CANNOT_RETRY",
        "EXECUTING_WITHDRAW",
        "HOT_NOT_ENOUGH_MONEY",
        "DUPLICATE_TO_ADDRESS"
      ]
    };
  },
  computed: {
    ...mapState("depositCheck", [
      "auditList",
      "allCoins",
      "audistCount",
      "pagination"
    ]),
    ...mapState(["userInfo"])
  },
  methods: {
    ...mapActions("depositCheck", [
      "ensure",
      "reset",
      "resetUserRecords",
      "abnormal",
      "cancel",
      "updateFreeze",
      "sendWithdrawalTrans",
      "remark",
      "manualConfirm",
      "returnToNotApproved"
    ]),
    ...mapActions('withdrawalAudit',['getUserWallet']),
    showPrompt(content, audit, callback) {
      return this.$prompt(content, "提示", {
        inputPlaceholder: "备注信息",
        inputValue: audit.remark
      }).then(({ value }) => {
        return callback()
          .then(() => {
            return value !== audit.remark
              ? this.remark({ id: audit.id, remark: value })
              : Promise.resolve(); //如果值未修改则不请求
          })
          .then(() => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.refreshList();
          });
      });
    },
    markAuditSuccess(audit) {
      this.showPrompt("确认通过审核吗？", audit, () => this.ensure(audit.id));
    },
    resetAudit(audit) {
      this.showPrompt(
        "重置会将人工审核状态还原为[未确认]，确认要重置吗？",
        audit,
        () => this.reset(audit.id)
      );
    },
    markAuditFailure(audit) {
      this.showPrompt("确认将该记录置为异常？", audit, () =>
        this.abnormal(audit.id)
      );
    },
    getUserDetail(uid) {
      this.getUserWallet({userId:uid});
      this.nowUserId = uid;
      this.showUserDialog = true;
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1
      });
    },
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    showSendDialog(id) {
      this.sendOrderId = id;
      this.ifShowSendDialog = true;
    },
    sendTransNow() {
      this.$refs["sendTransForm"].validate(valid => {
        if (valid) {
          this.sendWithdrawalTrans({
            id: this.sendOrderId,
            transId: this.sendTransForm.transId
          }).then(() => {
            this.closeSendDialog();
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.refreshList();
          });
        }
      });
    },
    closeSendDialog() {
      this.$refs["sendTransForm"] && this.$refs["sendTransForm"].resetFields();
      this.ifShowSendDialog = false;
    },
    handleManualConfirm(txId) {
      this.$confirm("确认手动转账已成功吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.manualConfirm(txId).then(() => {
          this.$message.success("操作成功！");
          this.refreshList();
        });
      });
    },
    handleReturnToNotApproved(txId) {
      this.$confirm("确认退回未审核状态吗？", "提示", {
        type: "warning"
      }).then(() => {
        this.returnToNotApproved(txId).then(() => {
          this.$message.success("操作成功！");
          this.refreshList();
        });
      });
    },
    getcopy(userid){
      let oInput = document.createElement('input'); 
      oInput.value = userid;    //赋值
      document.body.appendChild(oInput);
      oInput.select(); 
      document.execCommand("Copy"); 
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      this.$message.success('复制成功');
    }
  },
  components: {
    WithdrawRecords,
    Pagination,
    balance
  }
};
</script>

<style lang="less" scoped>
@import url("~styles/variables.less");

.account-link,
.network-link {
  color: @color-primary;
  &:hover {
    text-decoration: underline;
  }
}
.copystyle{
  display: flex;
  align-items: center;
  img{
    cursor:pointer;
  }
}
</style>
